export default __webpack_public_path__ + "static/media/logo-sulutgo.86320375.png";